// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"420":"7088479d","453":"9517778d","599":"70515cf1","871":"24d17075"}[chunkId] + ".chunk.js";
};